// extracted by mini-css-extract-plugin
export default {"addpages__info":"ModalAddPages_addpages__info__twZRB","addpages__additional":"ModalAddPages_addpages__additional__g84Fx"};